export default __webpack_public_path__ + "static/media/islamic-studies.6579378e.png";